@if (isFormReady) {
  <form class="form-horizontal" [formGroup]="entryForm">
    <div class="p-2">
      <div class="p-2">
        <div class="form-row row">
          <div class="col-12 col-lg-6">
            <div class="form-group row">
              <label for="name"
                    class="col-5 control-label required">
                {{'i18n.domain.administration.structural-entry-details.form-fields.name' | translate}}
              </label>
              <div class="col-7">
                <input type="text"
                      class="form-control e-textbox"
                      id="name"
                      formControlName="name">
                <app-error-messages [control]="entryForm.controls.name"></app-error-messages>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-6">
            <div class="form-group row">
              <label for="isSubscriptionSet"
                    class="col-5 control-label">
                {{'i18n.domain.administration.structural-entry-details.form-fields.is-subscription-set' | translate}}
              </label>
              <div class="col-7">
                <app-yes-no-group-button id="isSubscriptionSet" formControlName="isSubscriptionSet">
                </app-yes-no-group-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="detail-footer p-2 pt-3">
        @if (!!entryForm.controls.id.value) {
          <button type="button"
              class="btn btn-danger me-auto"
              (click)="onDelete()"
              [disabled]="isBusy">
            {{'i18n.domain.administration.structural-entry-details.messages.delete-title' | translate}}
          </button>
        }
        <button type="button"
                class="btn btn-primary"
                (click)="submitForm()"
                [disabled]="!entryForm.valid || !formChanged || isBusy">
          {{'i18n.shared.save' | translate}}
        </button>
        <button type="button"
                class="btn btn-secondary ms-2"
                (click)="onCancelClicked()"
                [disabled]="isBusy">
          {{cancelButtonText | translate}}
        </button>
      </div>
    </div>
  </form>
}
